import { Cell, Gutter, TickboxCell } from '@adserve/adserve-react-components';
import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';
import { RemoveById, ReplaceOrPushById } from '../../../../services/ArrayService';
import moment from 'moment';

const PropertySelectionTableRow = ({
    index,
    isHighlighted = false,
    activeProperty = {},
    disabled = false,
    setHighlightedRow,
    rowHeight,
    scrollPx = 0,
    onScroll,
    visibleRows,
    scrollableLength,
    selectedProperties,
    setSelectedProperties,
    setPropertyStatusMessage,
    checkedProperties = [],
    setCheckedProperties
}) => {
    const { formatCurrency, dateFormat } = useContext(SystemSettingsContext);

    const isSelected =
        checkedProperties.findIndex((sp) => sp.sandPPropertyId === activeProperty.sandPPropertyId) !== -1;

    /**
     * onClick event handler for the tickbox Cell
     */
    const onPropertySelect = () => {
        if (disabled || !activeProperty?.id) {
            return;
        }
        if (isSelected) {
            setCheckedProperties(RemoveById(checkedProperties, activeProperty?.sandPPropertyId, 'sandPPropertyId'));
            // if (activeProperty?.propertyDurationType === 1 || activeProperty?.propertyDurationType === '1' || activeProperty?.propertyDurationType === 'Finite') {
            // Not sure why the if statement. If unselected should remove from Selected Properties if this needs to go back check with Arif
            setSelectedProperties(RemoveById(selectedProperties, activeProperty?.sandPPropertyId, 'sandPPropertyId'));
            // }
        } else {
            activeProperty.sandPPropertyId = activeProperty.id;
            activeProperty.id = window.emptyGuid;
            activeProperty.isProperty = true;
            setCheckedProperties(ReplaceOrPushById(checkedProperties, activeProperty, 'sandPPropertyId'));
            setSelectedProperties(
                ReplaceOrPushById(
                    selectedProperties,
                    activeProperty,
                    'sandPPropertyId',
                    !(
                        activeProperty?.propertyDurationType === 1 ||
                        activeProperty?.propertyDurationType === '1' ||
                        activeProperty?.propertyDurationType === 'Finite'
                    )
                )
            );
        }
    };

    /**
     * onMouseOver event handler for every cell in the current row
     */
    const handleMouseOver = () => {
        if (disabled) {
            return;
        }
        setHighlightedRow(index);
    };

    /**
     * onMouseOut event handler for every cell in the current row
     */
    const handleMouseOut = () => {
        if (disabled) {
            return;
        }
        setHighlightedRow(-1);
    };

    return (
        <>
            <TickboxCell
                id={`propertyTickbox${index}`}
                size={20}
                index={index}
                onClick={onPropertySelect}
                value={isSelected}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            />
            <Cell
                id={`name${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            >
                {activeProperty.name}
            </Cell>
            <Cell
                id={`stationName${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            >
                {typeof activeProperty.linkedStationNames === 'string'
                    ? JSON.parse(activeProperty.linkedStationNames)?.formattedName
                    : activeProperty.linkedStationNames
                    ? activeProperty.linkedStationNames?.formattedName
                    : ''}
            </Cell>
            <Cell
                id={`propertyTypeDetail${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            >
                {activeProperty?.sandPPropertyCostingType?.name ?? ''}
            </Cell>
            <Cell
                id={`startDate${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            >
                {activeProperty.startDate
                    ? moment(activeProperty.startDate).utc(true).startOf('day').format(dateFormat)
                    : ''}
            </Cell>
            <Cell
                id={`endDate${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
            >
                {activeProperty.endDate
                    ? moment(activeProperty.endDate).utc(true).startOf('day').format(dateFormat)
                    : ''}
            </Cell>
            <Cell
                id={`propertyTotalSpots${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                scrollPx={scrollPx}
                visibleRows={visibleRows}
            >
                {activeProperty.propertyTotalSpots ?? ''}
            </Cell>
            <Cell
                id={`propertyAvailableSpots${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                scrollPx={scrollPx}
                visibleRows={visibleRows}
            >
                {activeProperty.propertyAvailableSpots ?? ''}
            </Cell>
            <Cell
                id={`propertyListPrice${index}`}
                index={index}
                rowHeight={rowHeight}
                isHighlighted={isHighlighted}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                scrollPx={scrollPx}
                visibleRows={visibleRows}
            >
                {formatCurrency(activeProperty.propertyListPrice)}
            </Cell>

            {index === 0 && (
                <Gutter
                    id='propertySelectionTableGutter'
                    scrollPx={scrollPx}
                    visibleRows={visibleRows}
                    onScroll={onScroll}
                    scrollableLength={scrollableLength}
                    maxVisibleLength={visibleRows * rowHeight}
                />
            )}

            {index >= visibleRows && <div id={`belowGutter${index}`} />}
        </>
    );
};

export default PropertySelectionTableRow;
